import axios from 'axios'
import store from '@/store/index.js'
import baseURL from './baseURL'
import { Message } from 'element-ui'
import router from '../router'
import { Toast } from "vant";

const http = {}

var instance = axios.create({
    timeout: 5000
    // baseURL
})

// 添加请求拦截器
instance.interceptors.request.use(    
    function(config) {
        //判断是否存在token,如果存在将每个页面header添加token
        //请求头添加token
        if (store.state.token) {
             config.headers['Authorization'] = 'Bearer '+ store.state.token
         }
        return config 
    },
    function(error) {
        router.push('/login')
        return Promise.reject(error)
    }
)

// 响应拦截器即异常处理
instance.interceptors.response.use( 
    response => {       
        return response.data
    },
    err => {
        if (err && err.response) {      
            switch (err.response.status) {
            case 400:
                if(err.response.data){
                    err.message = err.response.data
                }else{
                    err.message = '请求出错'
                }
  
                break
            case 401:
                Message.warning({
                    message: '授权失败，请重新登录'
                })
                store.commit('LOGIN_OUT')
                this.$router.push("/");//跳转到登录页
                /* setTimeout(() => {
                    window.location.reload()
                }, 1000) */

                return
            case 403:
                err.message = '拒绝访问'
                break
            case 404:
                err.message = '请求错误,未找到该资源'
                break
            case 500:
                err.message = '服务器端出错'
                break
            }
        } else {
            //console.log(err)
            err.message = '连接服务器失败'
        }
       /*  Message.error({
            message: err.message
        }) */
        Toast.warning(response.message);
        return Promise.reject(err.response)
    }
)

 http.get = async function(url, options) {
    return new Promise((resolve, reject) => {
        instance
            .get(url, options)
            .then(response => {
                if (response.code === 0) {
                    resolve(response)
                } else {
                    /* Message.error({
                        message: response.message
                    }) */
                    Toast({ message: response.message, position: "middle", duration: 3000 });
                    //reject(response.message)
                }
            })
            .catch(e => {
                console.log("http.get"+e)
            })
    })
}

http.post =async function(url, data, options) {
    return new Promise((resolve, reject) => {
        instance
            .post(url, data, options)
            .then(response => {
                if (response.code === 0) {
                    resolve(response)
                } else {
                   /*  Message.error({
                        message: response.message
                    }) */
                    Toast({ message: response.message, position: "middle", duration: 3000 });
                    //reject(response.message)
                }
            })
            .catch(e => {
                console.log("http.post"+e)
            })
    })
}
http.delete = async function(url, options) {
    return new Promise((resolve, reject) => {
        instance
            .delete(url, options)
            .then(response => {
                if (response.code === 0) {
                    resolve(response)
                } else {
                    /* Message.error({
                        message: response.message
                    }) */
                    Toast({ message: response.message, position: "middle", duration: 3000 });
                    //reject(response.message)
                }
            })
            .catch(e => {
                console.log("http.delete"+e)
            })
    })
}

export default http
